// 現在の月に応じて画像を表示するための関数
import React, { useState, useEffect } from 'react';

const MonthlyImage = () => {
   // 現在の月の画像を保持するための状態変数
  const [currentImage, setCurrentImage] = useState('');

   // コンポーネントがマウントされたときに実行される副作用フック
  useEffect(() => {
    // 現在の月を取得
    const month = new Date().getMonth() + 1; // JavaScriptは月を0から始めるので、1を足します。
     // 生成した画像パスを状態変数に設定
    const imagePath = `/images/${month}.png`; // `public` ディレクトリからの相対パスを使用
    setCurrentImage(imagePath);
  }, []);// マウント時にのみ実行されるため、依存配列は空です

  return (
    <div className='MonthlyImage'>
      <img src={currentImage} alt="Monthly Special" />
    </div>
  );
};

export default MonthlyImage;
